import type { AddressType } from '../types/miscTypes';
import { DEFAULT_SEPARATOR } from './apiUtils';

export const US_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'AS',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'VI',
  'WA',
  'WV',
  'WI',
  'WY'
];

export const US_STATE_SELECT_OPTIONS = US_STATES.map((state) => ({
  value: state,
  label: state
}));

export const addressToString = (address: AddressType): string => {
  const isBlank = Object.values(address).every((value) => value === '');
  if (isBlank) {
    return '';
  }

  return [
    address.address1,
    address.address2,
    address.city,
    address.state,
    address.zipCode
  ].join(DEFAULT_SEPARATOR);
};

export const getAddressFromString = (addressString: string): AddressType => {
  const addressSplit = addressString.split(DEFAULT_SEPARATOR);
  if (addressSplit.length !== 5) {
    throw Error('Invalid address string');
  }

  return {
    address1: addressSplit[0],
    address2: addressSplit[1],
    city: addressSplit[2],
    state: addressSplit[3],
    zipCode: addressSplit[4]
  };
};
